/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pricing_Standard_Price_Per_Month_SingularInputs */



/**
* | output |
* | --- |
* | "per month · {count} users" |
*
* @param {Pricing_Standard_Price_Per_Month_SingularInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_standard_price_per_month_singular = /** @type {((inputs: Pricing_Standard_Price_Per_Month_SingularInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Standard_Price_Per_Month_SingularInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`pro Monat · ${i?.count} Nutzer`)
	return /** @type {LocalizedString} */ (`per month · ${i?.count} users`)
});